<div class="d-flex flex-row align-items-center h-100">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12 text-center">
        <span class="display-1 d-block">404</span>
        <div class="mb-4 lead">Hledaný obsah nebyl nalezen.</div>
        <a href="/" class="btn btn-link">
          {{ 'Zpět do IREDA' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
